export default function SectionEyebrow({ children, className = "" }) {
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <span className="block w-10 h-px bg-accent-line" />
      <span className="text-[11px] tracking-luxe uppercase text-accent-line font-sans">
        {children}
      </span>
    </div>
  );
}
